import type { MyIcon } from '@repo/icons';
import type { TestId } from '@repo/test-id';
import classNames from 'classnames';
import type { ReactNode } from 'react';

interface Props {
  className: string;
  title: string;
  icon: MyIcon;
  testId: TestId;
  children?: ReactNode;
  info?: string;
}

export default function StatusInfo({ className, title, icon, testId, children, info }: Props) {
  const Icon = icon;

  return (
    <div
      className={classNames(className, 'relative -top-3.5 z-4 -mb-3.5 rounded-b-2xl px-4 pt-5 pb-2')}
      data-testid={testId}
    >
      <div className="flex gap-2 pb-1">
        <div className="pt-2.5">
          <Icon />
        </div>
        <div className="flex w-full flex-col gap-1.5">
          <div className="pt-2 text-base leading-6 font-medium text-balance">{title}</div>
          {info && <div className="text-sm leading-5 text-balance">{info}</div>}
          {children}
        </div>
      </div>
    </div>
  );
}
